function writeHTMLRecur(d, html) {
  d.write(html);
  var iframes = d.querySelectorAll('iframe');
  for (var i = 0; i < iframes.length; i++) {
    var iframe = iframes[i];
    console.log(iframe.innerHTML);
    writeHTMLRecur(iframe.contentDocument, iframe.innerHTML);
  }
}

export default function preview(html, width, height) {
  var w = window.open('');
  writeHTMLRecur(w.document, '<html><head><style>.rc-item{width: '+width+'px; height: '+height+'px} .rc-photo{background-position: center center;background-repeat: no-repeat;background-size: cover;}</style></head><body>' + html + '</body></html>');
}